<div style="margin: 0 1.5em;">
    <table class="mt-table mt-table-striped" aria-label="table-component">
        <thead >
            <tr>
                <th scope="col" *ngFor="let head of tableView?.headers">{{ head | lang}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let body of tableView?.dataSet">
                <td *ngFor="let item of body.items">
                    <!-- TEXT -->
                    <ng-container *ngIf="item.text !== null">
                        {{ item.text }}
                    </ng-container>
                    <ng-container *ngIf="item.text === null">
                        -
                    </ng-container>
                    
                    <!-- BADGE AND TOOLTIP -->
                    <ng-container *ngIf="item.badge != null">
                        <span *ngIf="item.badge.text != null; else blank" class="mt-badge"
                            [ngStyle]="{'background-color': item.badge.color,'color': item.badge.color ? '#FFFFFF' : '#433E3E' }"
                            [ngbTooltip]="item.badge.tooltip != null ? ttContent : null" placement="right"
                            tooltipClass="mt-tooltip">
                            {{ item.badge.text }}
                        </span>
                        <ng-template #blank>-</ng-template>
                        <ng-template #ttContent>
                            <ng-container *ngIf="item.badge.tooltip != null">
                                <div [innerHTML]="item.badge.tooltip"></div>
                            </ng-container>
                        </ng-template>
                    </ng-container>
                </td>
            </tr>
        </tbody>
    </table>
</div>
